type BrowsingContextSuggestion = {
  confidence: number;
  parts: {
    country: {
      confidence: number;
      handle: string;
      name: string;
      options: {
        [country: string]: string;
      };
    };
    language?: {
      confidence: number;
      handle: string;
      name: string;
      options: {
        [country: string]: string;
      };
    };
  };
};

type BrowsingContextSuggestions = {
  confidence: number;
  detected_values: {
    country: {
      handle: string;
      name: string;
    };
  };
  suggestions: BrowsingContextSuggestion[];
};

export const fetchGeolocationSuggestions = async (): Promise<
  BrowsingContextSuggestions | undefined
> => {
  try {
    const res = await fetch(
      window.Shopify?.routes?.root +
        "browsing_context_suggestions.json" +
        "?country[enabled]=true" +
        `&country[exclude]=${window.Shopify.country}`
    );

    return await res.json();
  } catch (error) {
    console.error(error);
  }
};
